
$(function () {
    $("body").on("click", function () {
        $(".widget.widget-search-box ul").hide();
    });

    $("body").off("paste", ".widget-search-box input[type=text]")
        .on("paste", ".widget-search-box input[type=text]", function () {
            $(this).parents(".widget-search-box").children("input[type=hidden]").val(null);
        });


    $("body").off("keyup", ".widget-search-box input[type=text]")
        .on("keyup", ".widget-search-box input[type=text]", function () {
            $(this).parents(".widget-search-box").children("input[type=hidden]").val(null);

            var baseUri = $(this).attr("search-box-url");
            var param = $(this).attr("search-box-param");
            var customerId = $(this).attr("search-box-customer-id");
            var value = $(this).val();

            if (!value) {
                $(this).parents(".widget-search-box").children("input[type=hidden]").val(" ");
                $(this).parents(".widget-search-box").trigger(WidgetEvents.STEMS_ON_CHANGE, [{ text: null, value: null }]);
            }

            onSearchBoxGo($(this).parent(), baseUri, param, value, customerId);
        });

    $("body").off("click", ".widget-search-box ul li")
        .on("click", ".widget-search-box ul li", function (e) {
            var id = $(this).data("id");
            var name = $(this).html();
            var clearOnSelect = $(this).parents(".widget-search-box").data("clear-on-select");
           
            if (clearOnSelect) {
                $(this).parents(".widget-search-box").children("input[type=text]")
                    .val(null);//.trigger(WidgetEvents.STEMS_ON_CHANGE, [{ text: name, value: id }]);
                $(this).parents(".widget-search-box").children("input[type=hidden]").val(null);
                $(this).parents(".widget-search-box").trigger(WidgetEvents.STEMS_ON_CHANGE, [{ text: name, value: id }]);
            }
            else {
                $(this).parents(".widget-search-box").children("input[type=text]").val(name);
                    //.trigger(WidgetEvents.STEMS_ON_CHANGE, [{ text: name, value: id }]);
                $(this).parents(".widget-search-box").children("input[type=hidden]").val(id);
                $(this).parents(".widget-search-box").trigger(WidgetEvents.STEMS_ON_CHANGE, [{ text: name, value: id }]);
            }


            //var event = e || window.event;
            //event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        });
})



function onSearchBoxGo(parent, baseUrl, param, value, customerId) {

    var queryString = "?" + param + "=" + value;

    if (customerId) queryString += "&customerId=" + customerId.toString();

    $.ajax({
        type: "GET",
        url: baseUrl + queryString,
        cache: false,
        dataType: "json",
        success: function (d, s, x) {
            parent.children("ul").html("");
            for (var i = 0; i < d.length; i++) {
                $li = $("<li>" + d[i].name + "</li>");
                $li.data("id", d[i].id);
                parent.children("ul").show().append($li);
            }
        },
        error: function (x, s, e) {
        }
    });
}